// extracted by mini-css-extract-plugin
export var AuthActionModal = "AuthActionModal-module--AuthActionModal--w7OlW";
export var AuthActionModal_container = "AuthActionModal-module--AuthActionModal_container--cKVuI";
export var AuthActionModal_content = "AuthActionModal-module--AuthActionModal_content--pit83";
export var AuthActionModal_content_item = "AuthActionModal-module--AuthActionModal_content_item--4QFb7";
export var AuthActionModal_header = "AuthActionModal-module--AuthActionModal_header--xvlg+";
export var AuthActionModal_header_label = "AuthActionModal-module--AuthActionModal_header_label--goyGO";
export var fadeIn = "AuthActionModal-module--fadeIn--Cxkys";
export var slideInUp = "AuthActionModal-module--slideInUp--BCPT7";